import React,{Component} from "react";
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { loginService } from "../../services/login.service";
import { helperText } from "../../_helpers/helpertext";
import { isStringEmpty } from "../../_helpers/string_helper";
import RegisterUserModel from "../../Models/RegisterUserModel";
import moment from "moment";
import { historypush } from "../../_helpers/utilities";
import Loader from "../../_helpers/Loader";
import { adminservice } from "../../services/admin.service";

var now = new Date();
var currentDate = moment(now).format("YYYY-MM-DD");
var minDate = moment.utc("0001-01-01");

class register extends Component{
    constructor(props){
        super(props);
        this.state={
            isLoading:false,
            userName:'',
            dob:'',
            nationality:'',
            recieptNumber:'',
            serialNumber:'',
            dateofReceipt:'',
            passportNumber:'',
            passportIssueDate:'',
            cdvNumber:'',
            cdcIssueDate:'',
            cdcIssuePlace:'',
            address:'',
            country:'',
            whatsAppNumber:'',
            mobileNumber:'',
            email:'',
            contactNumber:'',
            contactAddress:'',
            traininInstituteName:'',
            trainingCourse:'',
            traininInstituteAddress:'',
            joiningDate:'',
            courseCompletionDate:'',
            tarbookNumber:'',
            forCollection:'',
            forPayment:'',
            errorMessage: {},
            showNewSucessMessage:false,
            showEditSucessMessage:false,
            showFailureMessage:false,
            countryList:[],
            userId:0,
        }
        this.userInput=React.createRef();
        this.dobfocus=React.createRef();
        this.nationfocus=React.createRef();
        this.passnumfocus=React.createRef();
        this.passdoifocus=React.createRef();
        this.cdcfocus=React.createRef();
        this.cdcdoifocus=React.createRef();
        this.cdcplacefocus=React.createRef();
        
        this.addfocus=React.createRef();
        this.countryfocus=React.createRef();
        this.mobfocus=React.createRef();
        this.emailfocus=React.createRef();
        this.contaddfocus=React.createRef();

        this.instnamefocus=React.createRef();
        this.coursefocus=React.createRef();
        this.instaddfocus=React.createRef();
        this.joindatefocus=React.createRef();
        this.compldatefocus=React.createRef();

        this.collfocus=React.createRef();
        this.payfocus=React.createRef();

        this.codefocus=React.createRef();

    }

    componentDidMount=()=>{
        loadCaptchaEnginge(6); 
        this.getCountryList();
        let studentIdToEdit=localStorage.getItem("EditUserId");
        if(studentIdToEdit != undefined){
            this.setState({
                userId:studentIdToEdit,
            })
            this.getStudentDetail(studentIdToEdit);
        }
    }

    getStudentDetail=async(userId)=>{
        try{
            this.setState({isLoading:true});
            var response=await adminservice.GetStudentDetail(userId);
            if(response.status === 200){
                this.setState({
                    userId:response.data.userId,
                    userName:response.data.userName,
                    dob: moment(response.data.dob).format(
                        "YYYY-MM-DD"
                      ),
                    nationality:response.data.nationality,
                    recieptNumber:response.data.recieptNumber,
                    serialNumber:response.data.serialNumber,
                    dateofReceipt:moment(response.data.dateofReceipt).format(
                        "YYYY-MM-DD"
                      ),
                    passportNumber:response.data.passportNumber,
                    passportIssueDate:moment(response.data.passportIssueDate).format(
                        "YYYY-MM-DD"
                      ),
                    cdvNumber:response.data.cdvNumber,
                    cdcIssueDate:moment(response.data.cdcIssueDate).format(
                        "YYYY-MM-DD"
                      ),
                    cdcIssuePlace:response.data.cdcIssuePlace,
                    address:response.data.address,
                    country:response.data.country,
                    whatsAppNumber:response.data.whatsAppNumber,
                    mobileNumber:response.data.mobileNumber,
                    email:response.data.email,
                    contactNumber:response.data.contactNumber,
                    contactAddress:response.data.contactAddress,
                    traininInstituteName:response.data.traininInstituteName,
                    trainingCourse:response.data.trainingCourse,
                    traininInstituteAddress:response.data.traininInstituteAddress,
                    joiningDate:moment(response.data.joiningDate).format(
                        "YYYY-MM-DD"
                      ),
                    courseCompletionDate:moment(response.data.courseCompletionDate).format(
                        "YYYY-MM-DD"
                      ),
                    tarbookNumber:response.data.tarbookNumber,
                    forCollection:response.data.forCollection,
                    forPayment:response.data.forPayment,
                })
            }
            this.setState({isLoading:false});
            
        }
        catch(ex){
            return "";
        }
      }

    getCountryList=async()=>{
        this.setState({isLoading:true})
        var response=await loginService.GetCountryList();
        if(response.status === 200){
            this.setState({countryList:response.data});
        }

        this.setState({isLoading:false})
    }
    
      doSubmit = () => {
        // <! --   let's assume there is an HTML input text box with id 'user_captcha_input' to get user input -->   
             let user_captcha_value = document.getElementById('user_captcha_input').value;
             var error = this.state.errorMessage;
             if (validateCaptcha(user_captcha_value) === true) {
                error["emptyCaptcha"] = '';
                this.setState({ errorMessage: error });
                return true;
             }
             else {
                 //alert('Captcha Does Not Match');
                 if(user_captcha_value === ""){
                    error["emptyCaptcha"] = helperText.registerPageText.emptyCaptcha;
                    this.setState({ errorMessage: error });
                    this.codefocus.current.focus();
                    return false;
                 }else{
                    error["emptyCaptcha"] = helperText.registerPageText.wrongCaptcha;
                    this.setState({ errorMessage: error });
                    return false;
                 }
             }
         };


    onTextChange = (e) => {
        const { name, value } = e.target;
        this.setState({
          [name]: value,
        //   errorMessage: {},
        });
    };

    OnEventChange(event) {
        const { name, value } = event.target;
        this.setState(
          {
            [name]: value,
            // errorMessage: {},
          }
        );
      }

    saveUserDetails=async()=>{
        try{
           this.setState({isLoading:true})
            if(this.validate()){
                const{
                    userName,
                    dob,
                    nationality,
                    recieptNumber,
                    serialNumber,
                    dateofReceipt,
                    passportNumber,
                    passportIssueDate,
                    cdvNumber,
                    cdcIssueDate,
                    cdcIssuePlace,
                    address,
                    country,
                    whatsAppNumber,
                    mobileNumber,
                    email,
                    contactNumber,
                    contactAddress,
                    traininInstituteName,
                    trainingCourse,
                    traininInstituteAddress,
                    joiningDate,
                    courseCompletionDate,
                    tarbookNumber,
                    forCollection,
                    forPayment,
                    userId
                }=this.state;
                
                var register=new RegisterUserModel();
                register.userId = userId;
                register.userName = userName;
                register.dob = dob;
                register.nationality = nationality;
                register.recieptNumber = recieptNumber;
                register.serialNumber = serialNumber;
                register.dateofReceipt = dateofReceipt;
                register.passportNumber = passportNumber;
                register.passportIssueDate = passportIssueDate;
                register.cdvNumber = cdvNumber;
                register.cdcIssueDate = cdcIssueDate;
                register.cdcIssuePlace = cdcIssuePlace;
                register.address = address;
                register.country= country;
                register.whatsAppNumber = whatsAppNumber;
                register.mobileNumber = mobileNumber;
                register.email = email;
                register.contactNumber = contactNumber;
                register.contactAddress = contactAddress;
                register.traininInstituteName = traininInstituteName;
                register.trainingCourse = trainingCourse;
                register.traininInstituteAddress = traininInstituteAddress;
                register.joiningDate = joiningDate
                register.courseCompletionDate = courseCompletionDate;
                register.tarbookNumber = tarbookNumber;
                register.forCollection = forCollection;
                register.forPayment = forPayment;

                var response=await loginService.RegisterUser(register)
                if(response.status === 200){
                    if(response.data === true){
                        if(userId == 0 ){
                            this.setState({showNewSucessMessage:true});
                            historypush('/login');
                          }else{
                            this.setState({showEditSucessMessage:true});
                            historypush('/details');
                          }
                    }else{
                        this.setState({
                            showFailureMessage:true,
                        })
                    }
                }
            }
            this.setState({isLoading:false})
        }catch(ex){
            return '';
        }
    }

    /* <summary>
    date: 16-06-2022
    Name: VD
    description: This is used to Validate and check if the user has filled in all the necessary files
    <summary>*/ 
    validate=()=>{
        try{
            const{
                userName,
                dob,
                nationality,
                passportNumber,
                passportIssueDate,
                cdvNumber,
                cdcIssueDate,
                cdcIssuePlace,
                address,
                country,
                mobileNumber,
                email,
                contactAddress,
                traininInstituteName,
                trainingCourse,
                traininInstituteAddress,
                joiningDate,
                courseCompletionDate,
                forCollection,
                forPayment,
                userId,
            }=this.state;
            var isValid = true;
            var isCaptchaValid = true;
            //isValid = this.doSubmit();
            
            if(userId == 0){
                if(userName === "" ||
                    dob === "" ||
                    nationality === "" ||
                    passportNumber === "" ||
                    passportIssueDate === "" ||
                    cdvNumber === "" ||
                    cdcIssueDate === "" ||
                    cdcIssuePlace === "" ||
                    address === "" ||
                    country === "" ||
                    mobileNumber === "" ||
                    email === "" ||
                    contactAddress === "" ||
                    traininInstituteName === "" ||
                    trainingCourse === "" ||
                    traininInstituteAddress === "" ||
                    joiningDate === "" ||
                    courseCompletionDate === "" ||
                    forCollection === "" ||
                    forPayment === ""
                ){
                    isValid = false;
                }else{
                    isValid = true;
                }
            }else{
                if( userName === "" || 
                    userName === null || 
                    email === ""|| 
                    email === null ||
                    joiningDate === ""|| 
                    joiningDate === null)
                {
                    isValid = false;
                }else{
                    isValid = true;
                }
            }
            this.setState({ errorMessage: {} });
            var error = this.state.errorMessage;
            
            if(userId == 0){
                var user_captcha_value = document.getElementById('user_captcha_input').value;
                if (validateCaptcha(user_captcha_value) === true) {
                    error["emptyCaptcha"] = '';
                    this.setState({ errorMessage: error });
                    isCaptchaValid = true;
                } else {
                    //alert('Captcha Does Not Match');
                    if(user_captcha_value === ""){
                    error["emptyCaptcha"] = helperText.registerPageText.emptyCaptcha;
                    this.setState({ errorMessage: error });
                    this.codefocus.current.focus();
                    isCaptchaValid = false;
                    }else{
                    error["emptyCaptcha"] = helperText.registerPageText.wrongCaptcha;
                    this.setState({ errorMessage: error });
                    isCaptchaValid = false;
                    }
                }
            }
            
            if(userId == 0){
                if(isStringEmpty(forPayment)){
                    error["emptyForPayment"] = helperText.registerPageText.emptyForPayment;
                    this.setState({ errorMessage: error });
                    this.payfocus.current.focus();
                }else{
                    error["emptyForPayment"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(forCollection)){
                    error["emptyForCollection"] = helperText.registerPageText.emptyForCollection;
                    this.setState({ errorMessage: error });
                    this.collfocus.current.focus();
                }else{
                    error["emptyForCollection"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(courseCompletionDate) || moment.utc(courseCompletionDate).isSame(minDate)){
                    error["emptyCourseCompletionDate"] = helperText.registerPageText.emptyCourseCompletionDate;
                    this.setState({ errorMessage: error });
                    this.compldatefocus.current.focus();
                }else{
                    error["emptyCourseCompletionDate"] = '';
                    this.setState({ errorMessage: error });
                }
            }

            if(isStringEmpty(joiningDate) || moment.utc(joiningDate).isSame(minDate)){
                error["emptyJoiningDate"] = helperText.registerPageText.emptyJoiningDate;
                this.setState({ errorMessage: error });
                this.joindatefocus.current.focus();
            }else{
                error["emptyJoiningDate"] = '';
                this.setState({ errorMessage: error });
            }

            if(userId == 0){
                if(isStringEmpty(traininInstituteAddress)){
                    error["emptyTrainingInstituteAddress"] = helperText.registerPageText.emptyTrainingInstituteAddress;
                    this.setState({ errorMessage: error });
                    this.instaddfocus.current.focus();
                }else{
                    error["emptyTrainingInstituteAddress"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(trainingCourse)){
                    error["emptyTrainingCourse"] = helperText.registerPageText.emptyTrainingCourse;
                    this.setState({ errorMessage: error });
                    this.coursefocus.current.focus();
                }else{
                    error["emptyTrainingCourse"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(traininInstituteName)){
                    error["emptyTrainingInstituteName"] = helperText.registerPageText.emptyTrainingInstituteName;
                    this.setState({ errorMessage: error });
                    this.instnamefocus.current.focus();
                }else{
                    error["emptyTrainingInstituteName"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(contactAddress)){
                    error["emptyContactAddress"] = helperText.registerPageText.emptyContactAddress;
                    this.setState({ errorMessage: error });
                    this.contaddfocus.current.focus();
                }else{
                    error["emptyContactAddress"] = '';
                    this.setState({ errorMessage: error });
                }
            }
            if(isStringEmpty(email)){
                error["emptyEmail"] = helperText.registerPageText.emptyEmail;
                this.setState({ errorMessage: error });
                this.emailfocus.current.focus();
            }else{
                error["emptyEmail"] = '';
                this.setState({ errorMessage: error });
            }

            if(userId == 0){
                if(isStringEmpty(mobileNumber)){
                    error["emptyMobileNumber"] = helperText.registerPageText.emptyMobileNumber;
                    this.setState({ errorMessage: error });
                    this.mobfocus.current.focus();
                }else{
                    error["emptyMobileNumber"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(country)){
                    error["emptyCountry"] = helperText.registerPageText.emptyCountry;
                    this.setState({ errorMessage: error });
                    this.countryfocus.current.focus();
                }else{
                    error["emptyCountry"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(address)){
                    error["emptyAddress"] = helperText.registerPageText.emptyAddress;
                    this.setState({ errorMessage: error });
                    this.addfocus.current.focus();
                }else{
                    error["emptyAddress"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(cdcIssuePlace)){
                    error["emptyCDCIssuePlace"] = helperText.registerPageText.emptyCDCIssuePlace;
                    this.setState({ errorMessage: error });
                    this.cdcplacefocus.current.focus();
                }else{
                    error["emptyCDCIssuePlace"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(cdcIssueDate)){
                    error["emptyCDCIssueDate"] = helperText.registerPageText.emptyCDCIssueDate;
                    this.setState({ errorMessage: error });
                    this.cdcdoifocus.current.focus();
                }else{
                    error["emptyCDCIssueDate"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(cdvNumber)){
                    error["emptyCDCNumber"] = helperText.registerPageText.emptyCDCNumber;
                    this.setState({ errorMessage: error });
                    this.cdcfocus.current.focus();
                }else{
                    error["emptyCDCNumber"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(passportIssueDate)){
                    error["emptyPassportIssueDate"] = helperText.registerPageText.emptyPassportIssueDate;
                    this.setState({ errorMessage: error });
                    this.passdoifocus.current.focus();
                }else{
                    error["emptyPassportIssueDate"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(passportNumber)){
                    error["emptypassportNumber"] = helperText.registerPageText.emptypassportNumber;
                    this.setState({ errorMessage: error });
                    this.passnumfocus.current.focus();
                }else{
                    error["emptypassportNumber"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(nationality)){
                    error["emptyNationality"] = helperText.registerPageText.emptyNationality;
                    this.setState({ errorMessage: error });
                    this.nationfocus.current.focus();
                }else{
                    error["emptyNationality"] = '';
                    this.setState({ errorMessage: error });
                }

                if(isStringEmpty(dob)){
                    error["emptydob"] = helperText.registerPageText.emptyDob;
                    this.setState({ errorMessage: error });
                    this.dobfocus.current.focus();
                }else{
                    error["emptydob"] = '';
                    this.setState({ errorMessage: error });
                }
            }
            if(isStringEmpty(userName)){
                
                error["emptyuserName"] = helperText.registerPageText.emptyUserName;
                this.setState({ errorMessage: error });
                this.userInput.current.focus();
            }else{
                error["emptyuserName"] = '';
                this.setState({ errorMessage: error });
            }
            
            if(isCaptchaValid && isValid){
                return true;
            }else{
                return false;
            }
        }catch(error){
            return false;
        }

    }

    onChangeNumber = (e) => {
        var value = 0;
        if (e.target.value < 0) {
          value = 0;
        } else {
          value = e.target.value;
        }
        const { name } = e.target;
        this.setState({
          [name]: value,
        });
    
        // this.setState({
        //   errorMessage: {},
        // });
    };

    /* <summary>
    date: 21-06-2022
    Name: VD
    description: This is used to clear all data from the input 
    <summary>*/ 
    clearAll=()=>{
        this.setState({
            userName:'',
            dob:'',
            nationality:'',
            recieptNumber:'',
            serialNumber:'',
            dateofReceipt:'',
            passportNumber:'',
            passportIssueDate:'',
            cdvNumber:'',
            cdcIssueDate:'',
            cdcIssuePlace:'',
            address:'',
            country:'',
            whatsAppNumber:'',
            mobileNumber:'',
            email:'',
            contactNumber:'',
            contactAddress:'',
            traininInstituteName:'',
            trainingCourse:'',
            traininInstituteAddress:'',
            joiningDate:'',
            courseCompletionDate:'',
            tarbookNumber:'',
            forCollection:'',
            forPayment:'',
            showNewSucessMessage:false,
            showEditSucessMessage:false,
        })
    }

    render(){
        const{
            isLoading,
            userName,
            dob,
            nationality,
            recieptNumber,
            serialNumber,
            dateofReceipt,
            passportNumber,
            passportIssueDate,
            cdvNumber,
            cdcIssueDate,
            cdcIssuePlace,
            address,
            country,
            whatsAppNumber,
            mobileNumber,
            email,
            contactNumber,
            contactAddress,
            traininInstituteName,
            trainingCourse,
            traininInstituteAddress,
            joiningDate,
            courseCompletionDate,
            tarbookNumber,
            forCollection,
            forPayment,
            showNewSucessMessage,
            showEditSucessMessage,
            showFailureMessage,
            countryList,
            userId,
        }=this.state;
        return(
            <div>
                <div className="register-main-page">
                    {isLoading && <Loader />}
                <div className="container">
                    <div className="Register-form register">
                        <h4>Enter Candidate Information</h4>
                        <p className="requiredfield" style={{fontSize:'18px'}}>Please fill all the necessary fields (<i>*</i><span>indicates required field)</span></p>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>Personal Information</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Name of the Candidate:<span>*</span></h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.userInput}  className="form-control" name="userName" value={userName} onChange={this.onTextChange}/></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyuserName ? "contents" : "none",color: "red" }}>
                                    <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyuserName}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Date of Birth:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" ref={this.dobfocus} max={currentDate} className="form-control" id="number" name="dob" value={dob} onChange={this.onTextChange}/></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptydob ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptydob}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Nationality:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.nationfocus} className="form-control" id="name" name="nationality" value={nationality} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyNationality ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyNationality}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Receipt Number:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="text" className="form-control" style={{height:'41px'}} id="name" name="recieptNumber" value={recieptNumber} onChange={this.onTextChange} /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Serial Number:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="text" style={{height:'41px'}}  className="form-control" id="number" name="serialNumber" value={serialNumber} onChange={this.onTextChange} /></div>
                                </div>
                                <p>Shall be filled up after physically collecting or receipt of FG Tar Book</p>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Date of Receipt:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" className="form-control" data-date="" name="dateofReceipt" value={dateofReceipt} onChange={this.onTextChange} /></div>
                                </div>
                                <p>Shall be filled up after physically collecting or receipt of FG Tar Book</p>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>Passport Details</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Passport Number:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="text" style={{height:'41px'}} ref={this.passnumfocus} className="form-control" id="name" name="passportNumber" value={passportNumber} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptypassportNumber ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptypassportNumber}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Date of Issue:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" ref={this.passdoifocus} className="form-control" id="number" name="passportIssueDate" value={passportIssueDate} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5"  style={{ display: this.state.errorMessage.emptyPassportIssueDate ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyPassportIssueDate}</div>
                                </div>
                                </div>
                            </div>	
                            </div>
                        </div>
                        </div>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>CDC Details</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>CDC Number:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="text" style={{height:'41px'}} ref={this.cdcfocus} className="form-control" id="name" name="cdvNumber" value={cdvNumber} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyCDCNumber ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}> {this.state.errorMessage.emptyCDCNumber}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Date of Issue:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" ref={this.cdcdoifocus} className="form-control" id="number" name="cdcIssueDate" value={cdcIssueDate} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyCDCIssueDate ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>  {this.state.errorMessage.emptyCDCIssueDate}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Place of Issue:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.cdcplacefocus} className="form-control" id="name" name="cdcIssuePlace" value={cdcIssuePlace} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyCDCIssuePlace ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}> {this.state.errorMessage.emptyCDCIssuePlace}</div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>Contact Details</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                <div className="col-md-3"><label><h6>Address:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-9"><textarea type="name" ref={this.addfocus} className="form-control form-contol-mob" id="name" name="address" value={address} onChange={this.onTextChange} rows={2} style={{width: '94%'}}  /></div>
                                <div className="col-md-3"></div>
                                <div className="error-message col-11 col-md-9" style={{ display: this.state.errorMessage.emptyAddress ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>  {this.state.errorMessage.emptyAddress} </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                <div className="col-md-3"><label><h6>Country:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-4">
                                    <input type="name" ref={this.countryfocus} className="form-control form" id="name" name="country" value={country} onChange={this.onTextChange} />
                                    {/* <select
                                    className="form-select form-select-lg mb-3" 
                                    aria-label=".form-select-lg example"
                                    value={country}
                                    name="country"
                                    ref={this.countryfocus}
                                    onChange={this.OnEventChange.bind(this)}
                                    style={{fontSize:'17px',height:'41px', width: '94%'}}
                                    >
                                        {countryList.map((item)=>{
                                            return(
                                                <option value={item.countryId}>{item.countryName}</option>
                                            )
                                        })}
                                        
                                    </select> */}
                                </div>
                               </div>
                               <div className="row">
                                <div className="col-md-3"></div>
                                <div className="error-message col-11 col-md-9"  style={{ display: this.state.errorMessage.emptyCountry ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>  {this.state.errorMessage.emptyCountry} </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Whatsapp Number:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" className="form-control" id="number" name="whatsAppNumber" value={whatsAppNumber} onChange={this.onTextChange} style={{height:'41px'}} /></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Mobile Number:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.mobfocus} className="form-control" id="number" name="mobileNumber" value={mobileNumber} onChange={this.onTextChange} style={{height:'41px'}} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyMobileNumber ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyMobileNumber} </div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Email:<span>*</span></h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.emailfocus} className="form-control" id="name" name="email" value={email} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyEmail ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyEmail}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Contact Number:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" className="form-control" id="number" name="contactNumber" value={contactNumber} onChange={this.onTextChange} style={{height:'41px'}} /></div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-3"><label><h6>Contact Address:{userId == 0?<span>*</span>:""}</h6></label></div>
                                    <div className="col-11 col-md-9"><textarea type="name" ref={this.contaddfocus} className="form-control form-contol-mob" id="name" name="contactAddress" value={contactAddress} onChange={this.onTextChange} rows={2} style={{width: '94%'}} required /></div>
                                    <div className="col-md-3"></div>
                                    <div className="error-message col-11 col-md-9"  style={{ display: this.state.errorMessage.emptyContactAddress ? "contents" : "none",color: "red" }}>
                                    <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyContactAddress}</div>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>Initial Training Course Details</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Training Institute Name:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.instnamefocus} className="form-control" id="name" name="traininInstituteName" value={traininInstituteName} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-6"  style={{ display: this.state.errorMessage.emptyTrainingInstituteName ? "block" : "none",color: "red" }}>
                                <div style={{paddingLeft:"0px",marginTop:'-5px'}}>{this.state.errorMessage.emptyTrainingInstituteName}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Training Course:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="name" ref={this.coursefocus} className="form-control" id="name" name="trainingCourse" value={trainingCourse} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5"  style={{ display: this.state.errorMessage.emptyTrainingCourse ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyTrainingCourse}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                <div className="col-md-3"><label><h6>Training Institute Address:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-9"><textarea type="name" ref={this.instaddfocus} className="form-control form-contol-mob" id="name" name="traininInstituteAddress" value={traininInstituteAddress} onChange={this.onTextChange} rows={2} style={{width: '94%'}} /></div>
                                <div className="col-md-3"></div>
                                <div className="error-message col-11 col-md-9"style={{ display: this.state.errorMessage.emptyTrainingInstituteAddress ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>  {this.state.errorMessage.emptyTrainingInstituteAddress}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Joining Date:<span>*</span></h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" ref={this.joindatefocus} max={courseCompletionDate} className="form-control" id="date" name="joiningDate" value={joiningDate} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyJoiningDate ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}> {this.state.errorMessage.emptyJoiningDate}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Course Completion Date:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-11 col-md-5"><input type="date" ref={this.compldatefocus} min={joiningDate} className="form-control" id="date" name="courseCompletionDate" value={courseCompletionDate} onChange={this.onTextChange} /></div>
                                <div className="col-md-6"></div>
                                <div className="error-message col-11 col-md-5"  style={{ display: this.state.errorMessage.emptyCourseCompletionDate ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyCourseCompletionDate}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-md-6"><label><h6>Pre Sea Tar Book Number:</h6></label></div>
                                <div className="col-11 col-md-5"><input type="text" className="form-control" id="number" name="tarbookNumber" value={tarbookNumber} onChange={this.onTextChange} style={{height:'41px'}} /></div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        <div className="personalinfo">
                        <div className="personaldata"><h5>Kindly indicate your choice for Payment and collection of Tar Book</h5></div>
                        <div className="table-data">
                            <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                <div className="col-md-3 col-lg-3"><label><h6>For Collection:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-md-12 col-lg-9">
                                    <select id="collection" 
                                    name="forCollection"
                                    onChange={this.OnEventChange.bind(this)}
                                    value={forCollection}
                                    style={{height:'41px'}}
                                    ref={this.collfocus}
                                    >
                                    <option disabled />
                                    <option value="I will collect personally">I will collect personally</option>
                                    <option value="Please send by mail at the registered address">Please send by mail at the registered address</option>
                                    </select>
                                </div>
                                <div className="col-md-3 col-lg-3"></div>
                                <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyForCollection ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}>{this.state.errorMessage.emptyForCollection}</div>
                                </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="row">
                                <div className="col-md-3 col-lg-3"><label><h6>For Payment:{userId == 0?<span>*</span>:""}</h6></label></div>
                                <div className="col-md-12 col-lg-9">
                                    <select id="payment" 
                                    name="forPayment"
                                    onChange={this.OnEventChange.bind(this)}
                                    value={forPayment}
                                    style={{height:'41px'}}
                                    ref={this.payfocus}
                                    >
                                    <option disabled />
                                    <option value="I will pay by cash at time of collection of tar book from Nerul, Navi Mumbai">I will pay by cash at time of collection of tar book from Nerul, Navi Mumbai</option>
                                    <option value="I want to pay buy Online through website/ Personal Net banking">I want to pay buy Online through website/ Personal Net banking</option>
                                    </select>
                                </div>
                                <div className="col-md-3 col-lg-3"></div>
                                <div className="error-message col-md-12 col-lg-9"   style={{ display: this.state.errorMessage.emptyForPayment ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}> {this.state.errorMessage.emptyForPayment}</div>
                                </div>
                                </div>
                            </div>
                            {userId ==0?
                            <div className="col-md-6">
                                <div className="row">
                                <div className="col-6 col-md-6"><label><h6>Enter Code:<span>*</span></h6></label></div>
                                <div className="col-5 col-md-5"><input type="name" ref={this.codefocus} className="form-control" id="user_captcha_input" name="code" /></div>
                                <div className="col-6 col-md-6"></div>
                                <div className="error-message col-5 col-md-5"    style={{ display: this.state.errorMessage.emptyCaptcha ? "contents" : "none",color: "red" }}>
                                <div style={{paddingLeft:"13px",marginTop:'-5px'}}> {this.state.errorMessage.emptyCaptcha}</div>
                                </div>
                                </div>
                            </div>
                            :""}
                            {userId == 0?
                                <div className="col-md-6">
                                    {/* <div className="row captchabutton">
                                    <div className="col-6 col-md-6"><img src={CAPTCHA2} alt="captcha" /></div>
                                    <div className="col-5 col-md-5"><button type="button" className="btn">Refresh</button></div>
                                    </div> */}
                                    <LoadCanvasTemplate />
                                </div>
                            :""}
                            </div>
                        </div>
                        </div>
                        <div className="registerbutton">
                        <button type="button" className="btn Login-btn" onClick={this.saveUserDetails}>{userId == 0?"REGISTER":"SAVE"}</button>
                        <button type="button" className="cancel-btn btn" onClick={this.clearAll}>CANCEL</button>
                        <p className="mt-2">Already have an account? <a href="/login">Click here</a></p>
                        </div>
                        {showNewSucessMessage && (
                            <div id="thank_you" className="alert alert-success" style={{ fontSize: '24px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                
                                Success! You have successfully registered.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                            </div>
                        )}
                        {showEditSucessMessage && (
                            <div id="thank_you" className="alert alert-success" style={{ fontSize: '24px'}}>
                                {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                                
                                Student details has been Successfully updated.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                            </div>
                        )}
                        {showFailureMessage && (
                            <div id="failure" className="alert" style={{fontSize: '24px', backgroundColor: '#e78c8c', borderColor: '#e47779', color: '#730f0f'}}>
                            {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">
                              ×
                            </a> */}
                            <strong>Error!</strong> Oops, something went wrong. Please try again later.
                            <button type="button" className="btn-close" data-bs-dismiss="alert" />
                          </div>
                        )}
                    </div>
                </div>
                </div>
            </div>
        )
    }
}

export default register;